import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { RadioButtonOptionCard, Text } from '@reveni-io/reveni-ui'

import { deliveryMethodTypeCards } from '../constants'
import SectionHeader from '../SectionHeader/SectionHeader'
import * as SharedStyles from '../styles'
import { deliveryMethodTypeInputName } from './constants'
import * as Styles from './styles'

const DeliveryMethodTypeSection = ({ value, onChange, disabled, showReadOnlyMessage }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <Styles.Container>
      <SectionHeader
        title={t('Tipo')}
        description={t(
          'Elige cómo enviarán los clientes sus productos de vuelta: esto determina las opciones de logística disponibles'
        )}
      />
      <SharedStyles.CardsGrid columns={2}>
        {deliveryMethodTypeCards.map(card => {
          return (
            <RadioButtonOptionCard
              key={card.value}
              icon={<card.Icon size={24} weight="thin" />}
              title={t(card.title)}
              description={t(card.description)}
              name={deliveryMethodTypeInputName}
              value={card.value}
              selected={value === card.value}
              disabled={disabled}
              onChange={onChange}
            />
          )
        })}
      </SharedStyles.CardsGrid>
      {showReadOnlyMessage && (
        <Text type="bodySRegular" color={theme.colors.text.muted}>
          {t(
            'El tipo de método no puede modificarse después de la creación. Si necesitas otro tipo, crea un nuevo método de devolución.'
          )}
        </Text>
      )}
    </Styles.Container>
  )
}

export default DeliveryMethodTypeSection
